export default __webpack_public_path__ + "static/cover-b5260e93858291d026ae0923cb0e99a4.png";